// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import { Box, Stack, Typography, } from '@mui/material';

// TODO: Import MUI icon
import { } from '@mui/icons-material';

// TODO: Import context
import { Context } from '../../Common/Context';
import { Text } from '../../Common/Text';

// TODO: Import custom component
import Slide from '../Slide_LT.jpg';

import BoxSubPage from '../../Common/BoxSubPage';
import BoxImage from '../../Common/BoxImage';
import DialogVideo from '../../Common/DialogVideo';
import StackImage from '../../Common/StackImage';
import { ContentTitle, } from '../../Common/TypographyTYH';
import { BoxGridColumnsContainer, BoxGridColumnsFullWidth } from '../../Common/BoxGridColumns';

const EnglishEducation = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component EnglishEducation Rendered');

    // TODO: Define useContext
    const context = React.useContext(Context);

    // TODO: Define variable

    // TODO: Define event

    // TODO: Return component
    return (
        <BoxSubPage
            id="EnglishEducation"
            image={Slide}
            title={Text.Top.Menu['LT'].Title[context.language]}
            subtitles={Text.Top.Menu['LT'].Subtitles}
        >
            <BoxImage src={`https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/MeetOurNativeEnglishTeachers_02.jpg`} sx={{ mb: 1, width: 1 }} />
            <Typography sx={{ mb: 1 }}>
                At TYH, we are fortunate to have 2 Native English Teachers: Miss Danika Lee and Miss Elsa Li. Aside from teaching oral lessons, our NETs regularly host English morning assemblies together, play interactive English games with our students, organise Show and Tell events and share their culture of growing up and living life in their home countries.
            </Typography>
            <BoxGridColumnsContainer>
                <Stack sx={{ alignItems: 'center' }}>
                    <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/MeetOurNativeEnglishTeachers_09.jpg" />
                    <Typography sx={{ alignItems: 'center', display: 'flex', gap: 1, mt: 1, }} variant="body1">
                        Miss Danika Lee
                        <Box component="img" src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/Ireland.png" sx={{ width: '25px' }} />
                    </Typography>
                </Stack>
                <Stack sx={{ alignItems: 'center' }}>
                    <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/MeetOurNativeEnglishTeachers_01.jpg" />
                    <Typography sx={{ alignItems: 'center', display: 'flex', gap: 1, mt: 1, }} variant="body1">
                        Miss Elsa Li
                        <Box component="img" src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/United_Kingdom.png" sx={{ width: '25px' }} />
                    </Typography>
                </Stack>
            </BoxGridColumnsContainer>
            <Typography>
                In this video, Miss Elsa Li delivers a few words about being a NET:
            </Typography>
            <Box sx={{ mb:2, position: 'relative', width: 1, }}>
                <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/VideoElsa.jpg" hover={true} sx={{ width: 1 }} />
                <DialogVideo url="https://youtu.be/ERFvHPluDAc" />
            </Box>
            <Typography sx={{ mb: 1 }}>
                On Valentine's Day, Miss Danika Lee interviewed students to share their thoughts on the meaning of love:
            </Typography>
            <Box sx={{ mb: 1, position: 'relative', width: 1, }}>
                <BoxImage src="https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/VideoDanika.jpg" hover={true} sx={{ width: 1 }} />
                <DialogVideo url="https://youtu.be/PDsMB3_yd88" />
            </Box>
            <BoxGridColumnsContainer>
                <BoxGridColumnsFullWidth>
                </BoxGridColumnsFullWidth>
                {[3, 11, 4, 10, 5, 6, 7, 8].map((index) => (
                    <BoxImage key={index} src={`https://www.pohtyh.edu.hk/Files/LearningAndTeacher/EnglishEducation/MeetOurNativeEnglishTeachers_${String(index).padStart(2, '0')}.jpg`} />
                ))}
            </BoxGridColumnsContainer>
        </BoxSubPage >
    );
};
export default EnglishEducation;